import { GridRowSelectionModel } from '@mui/x-data-grid';
import { apiService } from '.';
import {
    ChatAssistant,
    ChatAssistantFilter,
} from '../shared/types/chat-assistant';
import { ChatAssistantLogs } from '../shared/types/chat-assistant-logs';
import { ToastSwal } from '../components/components/general/toastSwals/toastSwal';

export const asyncGetChatAssistants = async (
    filters?: ChatAssistantFilter,
    page?: number,
    pageSize?: number
): Promise<{ items: ChatAssistant[]; length: number }> => {
    try {
        const {
            items: data,
        }: {
            items: { items: ChatAssistant[]; length: number };
        } = await apiService.get('/api/chat-assistant', {
            limit: pageSize || 20,
            page: page || 0,
            ...filters,
        });

        return data || { items: [], length: 0 };
    } catch (error) {
        return { items: [], length: 0 };
    }
};

export const asyncGetChatAssistant = async (
    idChatAssistant: string
): Promise<ChatAssistant | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: ChatAssistant;
        } = await apiService.get(`/api/chat-assistant/${idChatAssistant}`);

        return data;
    } catch (error) {}
};

export const asyncGetChatAssistantWithEnmascaredApi = async (
    idChatAssistant: string
): Promise<ChatAssistant | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: ChatAssistant;
        } = await apiService.get(
            `/api/chat-assistant/enmascared-api/${idChatAssistant}`
        );

        return data;
    } catch (error) {}
};

export const asyncCreateChatAssistant = async (info: ChatAssistant) => {
    try {
        const res: any = await apiService.post('/api/chat-assistant', info);
        return res;
    } catch (error) {}
};

export const asyncCreateBasisChatAssistant = async (info: ChatAssistant) => {
    try {
        const res: any = await apiService.post(
            '/api/chat-assistant/basic-assistant',
            info
        );
        return res;
    } catch (error) {}
};

export const asyncUpdateChatAssistant = async (
    id: string,
    chatAssistant: ChatAssistant
) => {
    try {
        const res: any = await apiService.patch(
            `/api/chat-assistant/${id}`,
            chatAssistant
        );
        return res;
    } catch (error) {}
};

export const asyncUpdateOnlyAttachments = async (
    id: string,
    chatAssistant: ChatAssistant
): Promise<ChatAssistant | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: ChatAssistant;
        } = await apiService.patch(
            `/api/chat-assistant/update-attachments/${id}`,
            chatAssistant
        );

        return data;
    } catch (error) {}
};

export const asyncDeleteChatAssistant = async (id: string | number) => {
    return await apiService.delete(`/api/chat-assistant/${id}`);
};

export const asyncUpdateChatAssistantLink = async (id: string | number) => {
    return await apiService.patch(`/api/chat-assistant/update-link/${id}`);
};

export const asyncValidateChatAssistantLink = async (id: string | number) => {
    try {
        const { items } = await apiService.get<{
            items: { id: string | null; displayName: string | null };
        }>(`/api/chat-assistant/validate-link/${id}`);
        return items;
    } catch (error) {
        return null;
    }
};

export const asyncDeleteAttachmentChatAssistant = async (
    id: string | number
) => {
    return await apiService.delete(`/api/chat-assistant/attachment/${id}`);
};

export const asyncDeleteMultipleAttachmentChatAssistant = async (
    ids: GridRowSelectionModel
) => {
    return await apiService.delete(`/api/chat-assistant/multiple-attachment`, {
        ids,
    });
};

export const asyncGetLastTenChats = async (
    id: string
): Promise<{ items: ChatAssistantLogs[]; length: number }> => {
    return await apiService.get(`/api/chat-assistant/last-conversations/${id}`);
};

export const asyncDownloadFile = async (
    id: string,
    fileId: string,
    threadId: string
): Promise<{ url: string; filename: string } | null> => {
    const result = await apiService.download(
        `/api/sam-assistant/get-file/${id}/${threadId}/${fileId}`
    );

    if (!result) {
        ToastSwal.fire({
            text: 'El archivo ha expirado, solicítalo nuevamente',
            icon: 'error',
            timer: 20000,
            position: 'center-end',
        });
        return null;
    }

    const { blob, filename } = result;
    const url = URL.createObjectURL(blob);

    return { url, filename };
};
